import React from 'react'

const EmptyBox = ({ size }) => {

    return (
        <div className={size}>

        </div>
    )
}

export default EmptyBox
